/* TinyTAN — カルーセル / タブ / スライドショー / カウントダウン
   ベンチ(podmodturkey8)の効果DNAを再現。依存なしの軽量実装。 */
(function () {
  /* ---- 商品カルーセル（横スクロール＋矢印・スワイプ） ---- */
  function initCarousel(rail) {
    var track = rail.querySelector('[data-tt-track]');
    if (!track) return;
    var prev = rail.querySelector('[data-tt-prev]');
    var next = rail.querySelector('[data-tt-next]');
    function step() {
      var item = track.querySelector('.tt-rail__item');
      return item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    }
    function update() {
      if (!prev || !next) return;
      prev.classList.toggle('is-off', track.scrollLeft <= 4);
      next.classList.toggle('is-off', track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
    }
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---- タブ切替 ---- */
  function initTabs(root) {
    var btns = [].slice.call(root.querySelectorAll('[data-tt-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-tt-panel]'));
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.getAttribute('data-tt-tab');
        btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-tt-panel') === i); });
      });
    });
  }

  /* ---- ヒーロー・スライドショー ---- */
  function initSlideshow(root) {
    var slides = [].slice.call(root.querySelectorAll('[data-tt-slide]'));
    if (!slides.length) return;
    var dotsWrap = root.querySelector('[data-tt-dots]');
    var i = 0, n = slides.length, timer = null;
    var interval = parseInt(root.dataset.interval, 10) || 5000;
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dots = slides.map(function (_, k) {
      var d = document.createElement('button');
      d.className = 'tt-slideshow__dot'; d.type = 'button'; d.setAttribute('aria-label', (k + 1) + '枚目');
      d.addEventListener('click', function () { go(k); reset(); });
      dotsWrap && dotsWrap.appendChild(d); return d;
    });
    function show(k) {
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === k); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === k); });
      i = k;
    }
    function go(k) { show((k + n) % n); }
    function reset() { if (timer) clearInterval(timer); if (n > 1 && !reduce) timer = setInterval(function () { go(i + 1); }, interval); }
    var pv = root.querySelector('[data-tt-slide-prev]'), nx = root.querySelector('[data-tt-slide-next]');
    pv && pv.addEventListener('click', function () { go(i - 1); reset(); });
    nx && nx.addEventListener('click', function () { go(i + 1); reset(); });
    show(0); reset();
  }

  /* ---- カウントダウン ---- */
  function initCountdown(el) {
    var dl = el.dataset.deadline; if (!dl) { el.style.display = 'none'; return; }
    var end = new Date(dl).getTime(); if (isNaN(end)) { el.style.display = 'none'; return; }
    function pad(x) { return (x < 10 ? '0' : '') + x; }
    function tick() {
      var t = end - Date.now();
      if (t < 0) { el.textContent = ''; el.style.display = 'none'; return; }
      var d = Math.floor(t / 86400000), h = Math.floor(t / 3600000) % 24, m = Math.floor(t / 60000) % 60, s = Math.floor(t / 1000) % 60;
      el.textContent = (d > 0 ? d + '日 ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    tick(); setInterval(tick, 1000);
  }

  function boot() {
    document.querySelectorAll('[data-tt-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-tt-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-tt-slideshow]').forEach(initSlideshow);
    document.querySelectorAll('[data-tt-countdown]').forEach(initCountdown);
  }
  document.readyState !== 'loading' ? boot() : document.addEventListener('DOMContentLoaded', boot);
})();
